import { Carousel } from 'components/carousels/Carousel'
import routes from 'constants/routes'
import useTranslation from 'next-translate/useTranslation'
import { PropsWithChildren } from 'react'

export function SculpturesContainer({ children }: PropsWithChildren) {
  const { t } = useTranslation()

  return (
    <Carousel
      title={t('common:sculptures')}
      className='py-6 md:py-8'
      viewAllLabel={t('common:view_all')}
      viewAllHref={`${routes.artworks}?medium=Sculpture`}
    >
      {children}
    </Carousel>
  )
}
